"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var object_hash_1 = __importDefault(require("object-hash"));
var ServerStatusMonitorResponse_1 = require("./ServerStatusMonitorResponse");
/**
 * An instance of a server status monitor
 */
var ServerStatusMonitor = /** @class */ (function () {
    function ServerStatusMonitor(url) {
        this.ttl = 60;
        this.lastStatus = null;
        this.nextCheck = 0;
        this.loading = false;
        this.lastHash = null;
        this.callbacks = [];
        /*
         * Load up the initial server status the moment the object is created.
         */
        this.url = url;
        this.getServerStatus();
    }
    /**
     * Add an event listener to this
     * @param {string} type
     *  - Valid options are:
     *    load: Whenever a status has been loaded.
     *    updated: Whenever a status has been changed.
     * @param {Function} fn
     */
    ServerStatusMonitor.prototype.addEventListener = function (type, fn) {
        if (typeof fn === "function") {
            this.callbacks.push({ type: type, fn: fn });
        }
    };
    /**
     * Remove an event listener from this object
     * @param {string} type {@see addEventListener for types}
     *    updated: Whenever a status has been changed.
     * @param {Function} fn
     */
    ServerStatusMonitor.prototype.removeEventListener = function (type, fn) {
        var newCallbacks = [];
        for (var i in this.callbacks) {
            if (this.callbacks.hasOwnProperty(i) &&
                !(this.callbacks[i].type === type && this.callbacks[i].fn === fn)) {
                newCallbacks.push(this.callbacks[i]);
            }
        }
        this.callbacks = newCallbacks;
    };
    /**
     * An endpoint that will return a promise that resolves with the latest status update.
     * @returns {Promise<ServerStatusMonitorResponse>}
     */
    ServerStatusMonitor.prototype.getServerStatus = function () {
        var _this = this;
        /*
         * Return a new promise that will resolve with a ServerStatusMonitorResponse
         */
        return new Promise(function (resolve) {
            /*
             * If we are inside the TTL, return the existing payload.
             */
            if (_this.nextCheck > Date.now()) {
                resolve(_this.lastStatus);
            }
            else {
                /*
                 * Otherwise, ask the status server for an update.
                 */
                if (_this.loading) {
                    /*
                     * If we are already loading, wait until that has finished,and return that payload.
                     */
                    _this.loadingBounce(resolve);
                }
                else {
                    /*
                     * Set the loading flag.
                     */
                    _this.loading = true;
                    /*
                     * Perform a server request and resolve the promise.
                     */
                    _this.refreshServerStatus()
                        .then(function (response) {
                        /*
                         * If the request is successful, set the response
                         */
                        _this.lastStatus = response;
                    })
                        .catch(function (response) {
                        /*
                         * If there's an error then just set the response.
                         */
                        _this.lastStatus = response;
                    })
                        .finally(function () {
                        /*
                         * Finally, disable the loading flag, and set the last status event.
                         */
                        _this.loading = false;
                        _this.nextCheck = Date.now() + _this.ttl * 1000;
                        var hash = object_hash_1.default(_this.lastStatus);
                        _this.runCallbacks("load");
                        if (hash !== _this.lastHash) {
                            _this.lastHash = hash;
                            _this.runCallbacks("update");
                        }
                        setTimeout(function () {
                            _this.getServerStatus();
                        }, _this.ttl * 1000);
                        resolve(_this.lastStatus);
                    });
                }
            }
        });
    };
    /**
     *
     * @returns {Promise<ServerStatusMonitorResponse>}
     * @private
     */
    ServerStatusMonitor.prototype.refreshServerStatus = function () {
        var _this = this;
        return new Promise(function (resolve) {
            axios_1.default.get(_this.url)
                .then(function (response) {
                var data = response.data;
                // Sets the IsUp state of the message
                var isUp = data.hasOwnProperty("up") ? data.up : true;
                // If we have a TTL, then set it
                if (data.hasOwnProperty("ttl")) {
                    _this.ttl = data.ttl;
                }
                if (data.hasOwnProperty("message")) {
                    /*
                     * If the payload has a message component, resolve it.
                     */
                    resolve(new ServerStatusMonitorResponse_1.ServerStatusMonitorResponse(isUp, data.message.hasOwnProperty("text") ? data.message.text : null, data.message.hasOwnProperty("level") ? data.message.level : null));
                }
                else {
                    /*
                     * If the payload doesnt have a message, return a response without it.
                     */
                    resolve(new ServerStatusMonitorResponse_1.ServerStatusMonitorResponse(isUp));
                }
            })
                .catch(function () {
                /*
                 * If there's an error, then the the status server is down, let's continue as normal, but keep the same ttl
                 */
                resolve(new ServerStatusMonitorResponse_1.ServerStatusMonitorResponse(true));
            });
        });
    };
    /**
     * Run any bound callbacks based on their types.
     * @param {String} type
     */
    ServerStatusMonitor.prototype.runCallbacks = function (type) {
        for (var i in this.callbacks) {
            if (this.callbacks.hasOwnProperty(i)) {
                if (this.callbacks[i].type === type) {
                    this.callbacks[i].fn(this.lastStatus);
                }
            }
        }
    };
    /**
     * Perform a debounce on the loading request.
     * Once we are no longer loading resolve the promise function
     * @param {Function} fn The promise resolve function
     * @private
     */
    ServerStatusMonitor.prototype.loadingBounce = function (fn) {
        var _this = this;
        setTimeout(function () {
            if (_this.loading) {
                _this.loadingBounce(fn);
            }
            else {
                fn(_this.lastStatus);
            }
        }, 100);
    };
    return ServerStatusMonitor;
}());
exports.ServerStatusMonitor = ServerStatusMonitor;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2VydmVyU3RhdHVzTW9uaXRvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9TZXJ2ZXJTdGF0dXNNb25pdG9yL1NlcnZlclN0YXR1c01vbml0b3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxnREFBMEI7QUFDMUIsNERBQXFDO0FBQ3JDLDZFQUE0RTtBQUU1RTs7R0FFRztBQUNIO0lBU0UsNkJBQVksR0FBRztRQVJQLFFBQUcsR0FBVyxFQUFFLENBQUM7UUFDakIsZUFBVSxHQUFrQixJQUFJLENBQUM7UUFDakMsY0FBUyxHQUFXLENBQUMsQ0FBQztRQUN0QixZQUFPLEdBQVksS0FBSyxDQUFDO1FBRXpCLGFBQVEsR0FBa0IsSUFBSSxDQUFDO1FBQy9CLGNBQVMsR0FBUSxFQUFFLENBQUM7UUFHMUI7O1dBRUc7UUFDSCxJQUFJLENBQUMsR0FBRyxHQUFHLEdBQUcsQ0FBQztRQUNmLElBQUksQ0FBQyxlQUFlLEVBQUUsQ0FBQztJQUN6QixDQUFDO0lBRUQ7Ozs7Ozs7T0FPRztJQUNILDhDQUFnQixHQUFoQixVQUFpQixJQUFJLEVBQUUsRUFBRTtRQUN2QixJQUFJLE9BQU8sRUFBRSxLQUFLLFVBQVUsRUFBRTtZQUM1QixJQUFJLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxFQUFFLElBQUksTUFBQSxFQUFFLEVBQUUsSUFBQSxFQUFFLENBQUMsQ0FBQztTQUNuQztJQUNILENBQUM7SUFFRDs7Ozs7T0FLRztJQUNILGlEQUFtQixHQUFuQixVQUFvQixJQUFJLEVBQUUsRUFBRTtRQUMxQixJQUFNLFlBQVksR0FBRyxFQUFFLENBQUM7UUFDeEIsS0FBSyxJQUFNLENBQUMsSUFBSSxJQUFJLENBQUMsU0FBUyxFQUFFO1lBQzlCLElBQ0UsSUFBSSxDQUFDLFNBQVMsQ0FBQyxjQUFjLENBQUMsQ0FBQyxDQUFDO2dCQUNoQyxDQUFDLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLEtBQUssSUFBSSxJQUFJLElBQUksQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsQ0FBQyxFQUNqRTtnQkFDQSxZQUFZLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQzthQUN0QztTQUNGO1FBQ0QsSUFBSSxDQUFDLFNBQVMsR0FBRyxZQUFZLENBQUM7SUFDaEMsQ0FBQztJQUVEOzs7T0FHRztJQUNILDZDQUFlLEdBQWY7UUFBQSxpQkE2REM7UUE1REM7O1dBRUc7UUFDSCxPQUFPLElBQUksT0FBTyxDQUFDLFVBQUEsT0FBTztZQUN4Qjs7ZUFFRztZQUNILElBQUksS0FBSSxDQUFDLFNBQVMsR0FBRyxJQUFJLENBQUMsR0FBRyxFQUFFLEVBQUU7Z0JBQy9CLE9BQU8sQ0FBQyxLQUFJLENBQUMsVUFBVSxDQUFDLENBQUM7YUFDMUI7aUJBQU07Z0JBQ0w7O21CQUVHO2dCQUNILElBQUksS0FBSSxDQUFDLE9BQU8sRUFBRTtvQkFDaEI7O3VCQUVHO29CQUNILEtBQUksQ0FBQyxhQUFhLENBQUMsT0FBTyxDQUFDLENBQUM7aUJBQzdCO3FCQUFNO29CQUNMOzt1QkFFRztvQkFDSCxLQUFJLENBQUMsT0FBTyxHQUFHLElBQUksQ0FBQztvQkFFcEI7O3VCQUVHO29CQUNILEtBQUksQ0FBQyxtQkFBbUIsRUFBRTt5QkFDdkIsSUFBSSxDQUFDLFVBQUEsUUFBUTt3QkFDWjs7MkJBRUc7d0JBQ0gsS0FBSSxDQUFDLFVBQVUsR0FBRyxRQUFRLENBQUM7b0JBQzdCLENBQUMsQ0FBQzt5QkFDRCxLQUFLLENBQUMsVUFBQSxRQUFRO3dCQUNiOzsyQkFFRzt3QkFDSCxLQUFJLENBQUMsVUFBVSxHQUFHLFFBQVEsQ0FBQztvQkFDN0IsQ0FBQyxDQUFDO3lCQUNELE9BQU8sQ0FBQzt3QkFDUDs7MkJBRUc7d0JBQ0gsS0FBSSxDQUFDLE9BQU8sR0FBRyxLQUFLLENBQUM7d0JBQ3JCLEtBQUksQ0FBQyxTQUFTLEdBQUcsSUFBSSxDQUFDLEdBQUcsRUFBRSxHQUFHLEtBQUksQ0FBQyxHQUFHLEdBQUcsSUFBSSxDQUFDO3dCQUM5QyxJQUFNLElBQUksR0FBRyxxQkFBVSxDQUFDLEtBQUksQ0FBQyxVQUFVLENBQUMsQ0FBQzt3QkFDekMsS0FBSSxDQUFDLFlBQVksQ0FBQyxNQUFNLENBQUMsQ0FBQzt3QkFDMUIsSUFBSSxJQUFJLEtBQUssS0FBSSxDQUFDLFFBQVEsRUFBRTs0QkFDMUIsS0FBSSxDQUFDLFFBQVEsR0FBRyxJQUFJLENBQUM7NEJBQ3JCLEtBQUksQ0FBQyxZQUFZLENBQUMsUUFBUSxDQUFDLENBQUM7eUJBQzdCO3dCQUNELFVBQVUsQ0FBQzs0QkFDVCxLQUFJLENBQUMsZUFBZSxFQUFFLENBQUM7d0JBQ3pCLENBQUMsRUFBRSxLQUFJLENBQUMsR0FBRyxHQUFHLElBQUksQ0FBQyxDQUFDO3dCQUNwQixPQUFPLENBQUMsS0FBSSxDQUFDLFVBQVUsQ0FBQyxDQUFDO29CQUMzQixDQUFDLENBQUMsQ0FBQztpQkFDTjthQUNGO1FBQ0gsQ0FBQyxDQUFDLENBQUM7SUFDTCxDQUFDO0lBRUQ7Ozs7T0FJRztJQUNILGlEQUFtQixHQUFuQjtRQUFBLGlCQXNDQztRQXJDQyxPQUFPLElBQUksT0FBTyxDQUFDLFVBQUEsT0FBTztZQUN4QixlQUFLLENBQUMsR0FBRyxDQUFDLEtBQUksQ0FBQyxHQUFHLENBQUM7aUJBQ2hCLElBQUksQ0FBQyxVQUFBLFFBQVE7Z0JBQ1osSUFBTSxJQUFJLEdBQUcsUUFBUSxDQUFDLElBQUksQ0FBQztnQkFFM0IscUNBQXFDO2dCQUNyQyxJQUFNLElBQUksR0FBRyxJQUFJLENBQUMsY0FBYyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUM7Z0JBRXhELGdDQUFnQztnQkFDaEMsSUFBSSxJQUFJLENBQUMsY0FBYyxDQUFDLEtBQUssQ0FBQyxFQUFFO29CQUM5QixLQUFJLENBQUMsR0FBRyxHQUFHLElBQUksQ0FBQyxHQUFHLENBQUM7aUJBQ3JCO2dCQUNELElBQUksSUFBSSxDQUFDLGNBQWMsQ0FBQyxTQUFTLENBQUMsRUFBRTtvQkFDbEM7O3VCQUVHO29CQUNILE9BQU8sQ0FDTCxJQUFJLHlEQUEyQixDQUM3QixJQUFJLEVBQ0osSUFBSSxDQUFDLE9BQU8sQ0FBQyxjQUFjLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxJQUFJLEVBQzlELElBQUksQ0FBQyxPQUFPLENBQUMsY0FBYyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUNqRSxDQUNGLENBQUM7aUJBQ0g7cUJBQU07b0JBQ0w7O3VCQUVHO29CQUNILE9BQU8sQ0FBQyxJQUFJLHlEQUEyQixDQUFDLElBQUksQ0FBQyxDQUFDLENBQUM7aUJBQ2hEO1lBQ0gsQ0FBQyxDQUFDO2lCQUNELEtBQUssQ0FBQztnQkFDTDs7bUJBRUc7Z0JBQ0gsT0FBTyxDQUFDLElBQUkseURBQTJCLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQztZQUNqRCxDQUFDLENBQUMsQ0FBQztRQUNQLENBQUMsQ0FBQyxDQUFDO0lBQ0wsQ0FBQztJQUVEOzs7T0FHRztJQUNILDBDQUFZLEdBQVosVUFBYSxJQUFJO1FBQ2YsS0FBSyxJQUFNLENBQUMsSUFBSSxJQUFJLENBQUMsU0FBUyxFQUFFO1lBQzlCLElBQUksSUFBSSxDQUFDLFNBQVMsQ0FBQyxjQUFjLENBQUMsQ0FBQyxDQUFDLEVBQUU7Z0JBQ3BDLElBQUksSUFBSSxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLEtBQUssSUFBSSxFQUFFO29CQUNuQyxJQUFJLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUMsVUFBVSxDQUFDLENBQUM7aUJBQ3ZDO2FBQ0Y7U0FDRjtJQUNILENBQUM7SUFFRDs7Ozs7T0FLRztJQUNILDJDQUFhLEdBQWIsVUFBYyxFQUFFO1FBQWhCLGlCQVFDO1FBUEMsVUFBVSxDQUFDO1lBQ1QsSUFBSSxLQUFJLENBQUMsT0FBTyxFQUFFO2dCQUNoQixLQUFJLENBQUMsYUFBYSxDQUFDLEVBQUUsQ0FBQyxDQUFDO2FBQ3hCO2lCQUFNO2dCQUNMLEVBQUUsQ0FBQyxLQUFJLENBQUMsVUFBVSxDQUFDLENBQUM7YUFDckI7UUFDSCxDQUFDLEVBQUUsR0FBRyxDQUFDLENBQUM7SUFDVixDQUFDO0lBQ0gsMEJBQUM7QUFBRCxDQUFDLEFBL0xELElBK0xDO0FBL0xZLGtEQUFtQiJ9